<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-titlepage title-page automatic-title-page" epub:type="titlepage" id="title-page">
<div class="title-page-title-subtitle-block">
<h1 class="title-page-title">The SLIMY CHICKEN Zomnibus Edition</h1>
<h3 class="title-page-subtitle">Dan Shamble, Zombie P.I.</h3>
</div>
<div class="title-page-contributor-block">
<div class="title-page-contributor-primary-block">
<h2 class="title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"><span class="title-page-contributor-name">Kevin J. Anderson</span></h2>
</div>
</div>
<div class="publisher-block">
<div class="title-page-publisher-logo-block title-page-publisher-logo-aspect-square">
<div class="title-page-publisher-logo-size-container" style="width: 51.6%">
<a class="link-contains-image" href="http://www.wordfirepress.com" target="_blank"><img alt="WordFire Press" class="title-page-publisher-logo-image" src="images/wfp-logo-bw-words.jpg"/></a>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title-page.vue?fb0a07ba